module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUxMi4wMDV2NTEySDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDAzOWE2IiBkPSJNMCAxNzAuNjY3aDUxMi4wMDVWNTEySDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZDUyYjFlIiBkPSJNMCAzNDEuMzMzaDUxMi4wMDVWNTEySDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ru.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ru.svg
// module chunks = 0